export const findFullMatch = (text: string, searchTerm: string, word?: string) => {
  const fullMatchIndex = text.indexOf(searchTerm.trim());

  if (fullMatchIndex >= 0) {
    return [fullMatchIndex, fullMatchIndex + searchTerm.trim().length - 1 || word?.trim().length];
  }
};
